import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchFranchiseList,
  DeleteFranchiseRecord,
} from "../../services/FranchiseService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import delete_icon from "../../assets/images/icon/delete.svg";
import view_icon from "../../assets/images/icon/eye_icon.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import mail from "../../assets/images/icon/mail.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { getUserInfo } from "helpers/authHelper";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";

function FranchiseList(props) {
  const { t } = useTranslation();
  const [franchiseData, setfranchiseData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const userInfo = getUserInfo();
  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [csvData, setCSVData] = useState([]);

  const handleCSVDownload = async e => {
    e.preventDefault();
    if (franchiseData?.length === 0) {
      toast.error(t(`Franchise.No data Available`));
      return;
    }

    let allData = JSON.parse(JSON.stringify(franchiseData)) || [];
    allData = allData?.map(el => {
      el.statusText = el?.status === 1 ? "Active" : "Inactive";
      return el;
    });

    try {
      setCSVData(allData || []);
      setTimeout(() => {
        let element = document.getElementById("downloadCSV");
        element.click();
      }, 1000);
    } catch (err) {}
  };

  useEffect(() => {
    getFranchiseData();
  }, []);

  const getFranchiseData = async () => {
    await FetchFranchiseList()
      .then(res => {
        let response = decryptDataFromArray(res.data);

        if (response.status) {
          let data = response.data;
          // data = data.filter(item => item.status === 1);
          setfranchiseData(data);
        } else {
          toast.error(t(`Franchise.No data Available`));
        }
      })
      .catch(err => {
        toast.error(t(`Franchise.No data Available`));
      });
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allFranchises = franchiseData?.map(el => {
      if (el?.franchise_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setfranchiseData(allFranchises);
  };

  let columns = [
    // {
    //   dataField: "franchise_id",
    //   text: "Franchise Id",
    //   classes: "total di-fdriensp text-center",
    //   headerClasses: "text-center",
    //   formatter: (cellContent, row) => {
    //     return (
    //       <div className="date-tabel">
    //         {/* <input
    //           defaultChecked={row?.checked || false}
    //           onClick={e => handleCheck(e, row?.id)}
    //           type="checkbox"
    //         /> */}
    //         <label>{row.id}</label>
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "serial",
      text: t(`Franchise.Serial No`),
      formatter: (cell, row, rowIndex) => rowIndex + 1, // Adding 1 to rowIndex to start from 1
    },
    {
      dataField: "franchise_name",
      text: t(`Franchise.Franchise Name`),
      classes: "franchise-name ",
    },
    {
      dataField: "franchise_username",
      text: t(`Franchise.Franchise Username`),
      classes: "franchise-name ",
    },
    {
      dataField: "franchise_email",
      text: t(`Franchise.Franchise Email`),
      classes: "franchise-name ",
    },
    {
      dataField: "status",
      text: t(`Franchise.Status`),
      classes: "franchise-status ",
      formatter: (cell, row) => {
        return cell === 1 ? "Active" : "Inactive";
      },
    },
  ];

  
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Franchise.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleRejectedRecords = franchise_id => {
    DeleteFranchiseRecord(franchise_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (res.status == 200) {
          let messages = toast.success(responseData?.message);
          getFranchiseData();
          // window.location.reload();
        } else {
          toast.error(responseData?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//

  const options2 = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    totalSize: franchiseData.length,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = el => {
    if (!query) {
      return true;
    }
    let searchItem = JSON.stringify(el)?.toLowerCase();
    if (searchItem?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

if (!checkPermissionStatus("franchise-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Franchise.Access Denied`)}</h4>
      </div>
    );
  }
if (checkPermissionStatus("franchise-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Franchise.Actions`),
      formatter: (cell, row) => {
        let franchise_id = row.id;

        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <div
                onClick={() => handleRejectedRecords(franchise_id)}
                className="text-success blue-icon  blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title={t(`Franchise.Delete`)}
              >
                <img src={delete_icon} alt="delete_icon" />
                <span> {t(`Franchise.Delete`)}</span>
              </div>
            </div>

            <div className="action-one small-img">
              <Link
                to={{
                  pathname: `/view-franchise`,
                  state: {
                    formMode: "view",
                    data: {
                      franchise_details: franchiseData.find(
                        item => item.id === franchise_id
                      ),
                    },
                  },
                }}
              >
                <div
                  className="text-success blue-icon  blue-color3"
                  style={{ cursor: "pointer" }}
                  // to="#"
                  title={t(`Franchise.View`)}
                >
                  <img src={view_icon} alt="view_icon" />
                  <span> {t(`Franchise.View`)}</span>
                </div>
              </Link>
            </div>

            <div className="action-one small-img">
              <Link
                to={{
                  pathname: `/edit-franchise`,
                  state: {
                    formMode: "edit",
                    data: {
                      franchise_details: franchiseData.find(
                        item => item.id === franchise_id
                      ),
                    },
                  },
                }}
              >
                <div
                  className="text-success blue-icon  blue-color3"
                  style={{ cursor: "pointer" }}
                  title={t(`Franchise.Edit`)}
                >
                  <img src={edit_icon} alt="edit_icon" />
                  <span> {t(`Franchise.Edit`)}</span>
                </div>
              </Link>
            </div>
          </div>
        );
      },
    });
  }
  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="joblist-container create-vacancy main-pages-s">
          <Row className="mb-2 align-items-center">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Dealership List
                </h5>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table">
          <div className="franchise-list-page region-list-page aploc">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-application table-responsive pb-3">
                  <div className="table-data-search frenchise-list">
                    <div className="total-record">
                      <h5>
                        {t(`Franchise.Total Records`)}:{" "}
                        <span>{franchiseData?.length || 0}</span>
                      </h5>
                    </div>
                    <div className="total-serachbar">
                      <div className="serach-bar-top">
                        <form className="form-inline">
                          <input
                            className="form-control mr-sm-2"
                            type="search"
                            placeholder={t(
                              `Franchise.Search By Franchise Name`
                            )}
                            aria-label="Search"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            title={t(`Franchise.Search By Franchise Name`)}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>
                      {/* <div className="take-text">
                    <h5>
                    <span>
                        <img src={mail} alt="" />
                      </span>
                      Send CSV via Mail</h5>
                  </div> */}
                      {checkPermissionStatus(
                        "franchise-list",
                        "downloadcsv"
                      ) && (
                        <div className="take-text">
                          <CSVLink
                            data={csvData}
                            headers={[
                              {
                                key: "id",
                                label: t(`Franchise.Franchise ID`),
                              },
                              {
                                key: "franchise_name",
                                label: t(`Franchise.Franchise Name`),
                              },
                              {
                                key: "statusText",
                                label: t(`Franchise.Status`),
                              },
                            ]}
                            filename={`Dealership List.csv`}
                            id="downloadCSV"
                          >
                            <Button
                              color="info"
                              onClick={e => handleCSVDownload(e)}
                              outline
                            >
                              <img src={dowanload_csv} alt="Download" />{" "}
                              {t(`Franchise.Download CSV`)}
                            </Button>
                          </CSVLink>
                        </div>
                      )}
                      {checkPermissionStatus("franchise-list", "create") && (
                        <Link
                          to="/create-franchise"
                          className="btn btn-primary"
                        >
                          {t(`Franchise.Create Franchise`)}
                        </Link>
                      )}

                      <div className="tale-text right-panel mobile-arrow mb-0">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <div className="timeto-hire-card userlist  when-data-low  masterstate-cards"> */}
                  <div className="timeto-hire-card userlist pendiglist-cardss">
                    <div className="table-custome-class range-custome">
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          {franchiseData?.length > 0 && (
                            <ToolkitProvider
                              keyField="id"
                              data={franchiseData?.filter(renderCheck)}
                              columns={columns}
                              search
                            >
                              {props => (
                                <div
                                  className="table-wrapper"
                                  ref={tableWrapperRef}
                                >
                                  <BootstrapTable
                                    {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    rowClasses={rowClasses}
                                    hover
                                    responsive
                                  />
                                </div>
                              )}
                            </ToolkitProvider>
                          )}
                          {franchiseData?.length === 0 && (
                            <>
                              <div className="no-data data-available">
                                <img
                                  src="../../img/data-not-available.png"
                                  alt="data not availble"
                                />
                                <h3> {t(`Franchise.No Item Found`)}</h3>
                                <p>
                                  {t(`Franchise.Sorry, we could not find any`)}
                                  <br /> {t(`Franchise.Item to show here`)}
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FranchiseList;
